<template>
    <div class="page-container">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "PageContainer",
    data()
    {
        return {}
    },
    methods: {
        handleScroll(e) {
            this.$emit("scroll", e)
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/styles/common.scss";
.page-container
{
    width: 100%;
    height: 100%;
    padding: 0px 20px;
    display: flex;
    box-sizing: border-box;
    background: $body-color;
    flex-direction: column;
    overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/container/PageContainer.vue